var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestChartsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_1638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7886 24.2661H18.7092C18.2886 24.2661 17.9475 23.9382 17.9475 23.5337V7.7915C17.9475 7.38701 18.2886 7.05908 18.7092 7.05908H22.7886C23.2093 7.05908 23.5504 7.38701 23.5504 7.7915V23.5337C23.5504 23.9382 23.2093 24.2661 22.7886 24.2661Z",
    fill: "#5650FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7911 7.05908H20.7513V24.2661H22.7911C23.2117 24.2661 23.5528 23.9382 23.5528 23.5337V7.7915C23.5528 7.38701 23.2117 7.05908 22.7911 7.05908Z",
    fill: "#5650FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4472 24.2682H11.3678C10.9471 24.2682 10.6061 23.9402 10.6061 23.5357V2.302C10.6061 1.89751 10.9471 1.56958 11.3678 1.56958H15.4472C15.8679 1.56958 16.2089 1.89751 16.2089 2.302V23.5357C16.2089 23.9402 15.8679 24.2682 15.4472 24.2682Z",
    fill: "#5650FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10566 24.2677H4.02625C3.60557 24.2677 3.26453 23.9398 3.26453 23.5353V13.2847C3.26453 12.8802 3.60557 12.5522 4.02625 12.5522H8.10566C8.52633 12.5522 8.86737 12.8802 8.86737 13.2847V23.5353C8.86737 23.9398 8.52633 24.2677 8.10566 24.2677Z",
    fill: "#5650FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10443 12.5522H6.0647V24.2677H8.10443C8.5251 24.2677 8.86615 23.9398 8.86615 23.5353V13.2847C8.86615 12.8802 8.5251 12.5522 8.10443 12.5522Z",
    fill: "#5650FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2383 25H0.761719C0.341047 25 0 24.6721 0 24.2676V0.732422C0 0.32793 0.341047 0 0.761719 0C1.18239 0 1.52344 0.32793 1.52344 0.732422V23.5352H25.2383C25.659 23.5352 26 23.8631 26 24.2676C26 24.6721 25.659 25 25.2383 25Z",
    fill: "#5650FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2366 23.5352H13.4062V25H25.2366C25.6573 25 25.9983 24.6721 25.9983 24.2676C25.9983 23.8631 25.6573 23.5352 25.2366 23.5352Z",
    fill: "#5650FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_1638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestChartsIcon);
export default __webpack_public_path__ + "static/media/TestChartsIcon.178821c745dbea4c045f5cdda0016762.svg";
export { ForwardRef as ReactComponent };